<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Overview</h6>
          <h1 class="header-title">Reports</h1>
        </div><!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <div class="card">
        <ul class="list-data no-links no-hover">
          <capabilities-requiring-development/>

          <exceeding-graduates v-if="$userIsAdmin"/>

          <progressing-graduates v-if="$userIsAdmin"/>

          <pdp-completion-status/>

          <mid-point-checkin/>

          <bulk-pdp-download/>

          <reports-master-report v-if="$userIsAdmin"/>
        </ul><!-- /.list-data -->
      </div><!-- /.card -->
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { programComputed, programMethods } from 'vx/helpers'
import CapabilitiesRequiringDevelopment from './ReportsCapabilitiesRequiringDevelopment'
import ExceedingGraduates from './ReportsExceedingGraduates'
import ProgressingGraduates from './ReportsProgressingGraduates'
import PdpCompletionStatus from './ReportsPdpCompletionStatus'
import ReportsMasterReport from './ReportsMasterReport'
import MidPointCheckin from './ReportsMidPointCheckIn'
import BulkPdpDownload from './ReportsBulkPdpDownload'

export default {
  components: {
    ReportsMasterReport,
    CapabilitiesRequiringDevelopment,
    ExceedingGraduates,
    ProgressingGraduates,
    PdpCompletionStatus,
    BulkPdpDownload,
    MidPointCheckin
  },

  computed: {
    ...programComputed
  },

  created () {
    this.getPrograms({ oldest: false, without_trashed: true, report: true })
  },

  methods: {
    ...programMethods
  }
}
</script>
